import styled, { keyframes } from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const Wrapper = styled.div`
	height: 100%;
	display: flex;
	flex-direction: column;
`;

export const Main = styled.div`
	height: 100%;
	display: flex;
	flex-direction: column;
	overflow: auto;
`;

export const LoaderWrapper = styled.div`
	width: 100%;
	text-align: center;
	padding: 15% 0;
`;

export const Title = styled.div`
	font-style: normal;
	font-weight: 500;
	font-size: 23px;
	line-height: 31px;
	letter-spacing: 0.3px;
	color: ${colors.grey7};
	display: flex;
	padding: 16px 0 6px 0;
`;

export const SectionTitle = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	font-weight: 700;
	font-size: 19px;
	line-height: 27px;
	color: ${colors.grey8};
`;

export const Subtitle = styled.div`
	margin-left: 12px;
	font-style: normal;
	font-weight: 500;
	font-size: 13px;
	letter-spacing: 0.3px;
	color: ${colors.grey5};
	display: flex;
	align-items: flex-end;

	span {
		line-height: initial;
		padding-bottom: 5px;
	}
`;

const fadeAnimation = keyframes`
 	0% { opacity: 0; }
 	100% { opacity: 1; }
`;

export const FixedHeader = styled.div`
	position: fixed;
	z-index: 2;
	background-color: white;
	width: 100%;
	animation: ${fadeAnimation} 0.3s ease;
	display: flex;
	align-items: center;
	height: 48px;
	margin-left: -32px;
	padding-left: 32px;
`;

export const SecondaryWrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	background-color: ${colors.greyBg};
	padding: 32px;
	align-items: center;
`;

export const ChartWrapper = styled.div`
	padding: 0 32px;
	display: flex;
	flex-direction: column;
	width: ${props => (props.loadingTab2 ? 'auto;' : 'fit-content')};
`;

export const Section = styled.div`
	display: flex;
	flex-direction: column;
	padding: 32px;
	background-color: white;
	width: 1135px;
	box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.1);
	margin-bottom: 32px;
`;

export const ExportWrapper = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	background-color: white;
	padding-bottom: 10px;
	margin-bottom: -10px;
`;
